import { z } from 'zod';

import { DISCIPLINE_EVENT_TYPES } from '../enums';
import type { DisciplineEventType } from '../enums';
import { AccountIdSchema } from './account';

export const DisciplineEventListQuerySchema = z.object({
  accountId: AccountIdSchema,
  symbol: z.string().trim().min(1).optional(),
  type: z.enum(DISCIPLINE_EVENT_TYPES).optional(),
  includeInvalidated: z
    .enum(['true', 'false'])
    .default('false')
    .transform((value) => value === 'true'),
});

export type DisciplineEventEvidenceDto = Record<string, string | number | boolean | null>;

export interface DisciplineEventDto {
  id: string;
  accountId: string;
  symbol: string;
  tradePlanId: string | null;
  tradeId: string | null;
  type: DisciplineEventType;
  title: string;
  description: string;
  expected: DisciplineEventEvidenceDto;
  actual: DisciplineEventEvidenceDto;
  occurredAt: string;
  detectedAt: string;
  sourceInvalidatedAt: string | null;
  sourceInvalidationReason: 'SOURCE_CORRECTED' | 'SOURCE_DELETED' | null;
}
